/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

require('./bootstrap');

let lastActivityAt = new Date();
['click', 'keydown', 'scroll'].forEach(eventName => {
    window.addEventListener(eventName, () => {
        lastActivityAt = new Date();
    });
});

const $treshold = document.querySelector('meta[name="inactivity-timeout"]');
const treshold = $treshold ? parseInt($treshold.getAttribute('content')) : -1;

setInterval(() => {
    if (treshold < 0) return;

    const inactivityInSeconds = (new Date() - lastActivityAt) / 1000;

    if (inactivityInSeconds < 5 * 60) return;

    const logoutButton = document.querySelector('#logout-button');
    if (!logoutButton) return;

    logoutButton.click();
}, 1000);

setInterval(() => {
    fetch('/ping');
}, 30 * 1000)

// global.$ = require("jquery"); // jquery fix

// window.Vue = require('vue');
//
// /**
//  * The following block of code may be used to automatically register your
//  * Vue components. It will recursively scan this directory for the Vue
//  * components and automatically register them with their "basename".
//  *
//  * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
//  */
//
// // const files = require.context('./', true, /\.vue$/i)
// // files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))
//
// Vue.component('example-component', require('./components/ExampleComponent.vue').default);
//
// /**
//  * Next, we will create a fresh Vue application instance and attach it to
//  * the page. Then, you may begin adding components to this application
//  * or customize the JavaScript scaffolding to fit your unique needs.
//  */
//
// const app = new Vue({
//     el: '#app',
// });

require('datatables.net/js/jquery.dataTables');
require('datatables.net-bs4/js/dataTables.bootstrap4');
require('bootstrap-notify');
// require('block-ui');
require('bootstrap-select');
require('../../public/js/datatables/tables');
// require('@fancyapps/fancybox');

require('./forms');
require('./imagePreview');
require('./custom');

// require('../../public/js/import_wizard');
// var csv = require('jquery-csv');
// require('../../public/js/formulier_wizard');
